import { AnyAction } from '@reduxjs/toolkit';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import api from '../../apiServices';
import { ImageActions } from './ImageActions';
import { setImageLoading, setImages } from './ImageSlice';
import { selectImagesList } from './ImageSelector';

function* getListSaga(action: AnyAction): any {
  try {
    const images = yield select(selectImagesList);
    if (!images.length) {
      yield put(setImageLoading(true));
    }
    const data = action.payload?.pagination ? yield call(api.image.list, action.payload.pagination) : yield call(api.image.list);
    yield put(setImages([...data.list]));
  } catch (error) {
    console.log(error);
  } finally {
    yield put(setImageLoading(false));
  }
}

export function* imageSaga() {
  yield all([takeLatest(ImageActions.getList, getListSaga)]);
}
